import { useState } from 'react';
import { changePassword } from '../services/auth';
import { extractApiError } from '../utils/api-error';
import type { ChangePasswordPayload } from '../types/api';

export function useChangePassword() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (data: ChangePasswordPayload) => {
    setLoading(true);
    setError(null);
    try {
      await changePassword(data);
    } catch (err) {
      const msg = extractApiError(err, 'Error al cambiar la contraseña');
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { submit, loading, error, setError };
}
